import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import CustomCard, { ICustomCardProps } from 'components/cmn/CustomCard';

interface ILoginCardProps {
  children: ReactNode;
  other?: React.ForwardRefExoticComponent<ICustomCardProps & React.RefAttributes<unknown>>;
  isShadow?: boolean;
}
function LoginCard({ children, isShadow, ...other }: ILoginCardProps): JSX.Element {
  const location = useLocation();
  const isSignUp = location.pathname === '/admin/signup';
  return (
    <CustomCard
      shadow={isShadow}
      border={false}
      sx={{
        maxWidth: 640,
        maxHeight: 'calc(100vh)',
        overflowY: 'auto!important',
        '& > *': {
          flexGrow: 1,
          flexBasis: '50%',
        },
      }}
      {...other}
    >
      <Box
        sx={{ p: { xs: '3rem 4rem', md: isSignUp ? '40px 100px' : '83px 100px', overflow: 'auto', height: 'auto' } }}
      >
        {children}
      </Box>
    </CustomCard>
  );
}

export default LoginCard;
